import {SidebarContainer} from './Root'
import type {ChildrenProps} from './sidebar-context'
import styles from './Footer.module.css'

export function Footer(props: ChildrenProps) {
  return <SidebarContainer {...props} className={styles.Footer} data-component="Sidebar.Footer" />
}
